import { FEEDBACK_TYPES } from "shared/config/feedbackTypes";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import React from "react";
import SPACING from "shared/config/spacing";
import VStack from "shared/components/layout/stack/VStack";
import { FeedbackIcon, FormInputWrapperText, InputLabel } from "./FormInputWrapper.styles";

const RenderIcon = ({ feedbackType }) => {
    switch (feedbackType) {
        case FEEDBACK_TYPES.Success:
            return <FeedbackIcon size={17} name="success" color="Green" />;
        case FEEDBACK_TYPES.Warning:
            return <FeedbackIcon size={15} name="warning" color="Yellow" />;
        case FEEDBACK_TYPES.Error:
            return <FeedbackIcon name="error" color="Orange_1" />;
        default:
            return <></>;
    }
};

const FormInputWrapper = ({
    disabled,
    label,
    description,
    feedbackMessage,
    feedbackType,
    helpText,
    className,
    _spacing,
    isSmallSize,
    maxWidth = "100%",
    ...rest
}) => {
    return (
        <VStack
            spacing={isSmallSize ? "Zero_25" : "Zero_5"}
            className={className}
            css={("min-width: 64px", `max-width:${maxWidth}`)}
        >
            {(label || description) && (
                <div>
                    {label && (
                        <InputLabel
                            aria-disabled={disabled}
                            isDisabled={disabled}
                            {...rest}
                        >
                            {label}
                        </InputLabel>
                    )}
                    {description && (
                        <FormInputWrapperText
                            aria-disabled={disabled}
                            color="Gray_2"
                            variant="Descriptive_1_1"
                        >
                            {description}
                        </FormInputWrapperText>
                    )}
                </div>
            )}
            {rest.children}
            {(feedbackMessage || helpText) && (
                <div>
                    {feedbackMessage && (
                        <HStack spacing={SPACING.Zero_25} align="center">
                            <RenderIcon feedbackType={feedbackType} />
                            <FormInputWrapperText
                                aria-disabled={disabled}
                                color="Black"
                                variant="Body_2_2"
                            >
                                {feedbackMessage}
                            </FormInputWrapperText>
                        </HStack>
                    )}
                    {helpText && (
                        <FormInputWrapperText
                            aria-disabled={disabled}
                            color="Gray_2"
                            variant="Body_2_1"
                        >
                            {helpText}
                        </FormInputWrapperText>
                    )}
                </div>
            )}
        </VStack>
    );
};

FormInputWrapper.defaultProps = {
    disabled: false,
    label: null,
    description: null,
    feedbackType: FEEDBACK_TYPES.None,
    feedbackMessage: null,
    helpText: null,
    isSmallSize: false,
};

RenderIcon.propTypes = {
    feedbackType: PropTypes.oneOf(Object.keys(FEEDBACK_TYPES)),
};

FormInputWrapper.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    description: PropTypes.string,
    feedbackType: PropTypes.oneOf(Object.keys(FEEDBACK_TYPES)),
    feedbackMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isSmallSize: PropTypes.bool,
    _spacing: PropTypes.any,
    maxWidth: PropTypes.string,
    className: PropTypes.string,
};

export default FormInputWrapper;
